var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"uni-icons",class:[_vm.customIcons, _vm.customIcons ? _vm.type : ''],style:({ color: _vm.color, 'font-size': _vm.size + 'px' }),on:{"click":_vm._onClick}},[_vm._v(" "+_vm._s(_vm.icons[_vm.type])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }